import React, { useState, useEffect } from "react";
import CouponDetailsTemplate from "components/CouponDetailsTemplate";
import { connect } from "react-redux";
import MainTemplateHeader from "components/MainTemplateHeader";
import BrandedCouponDetails from "./BrandedCouponDetails";
import { Card, useMediaQuery } from "@mui/material";
import {
  handleDTCFavPharmacy,
  hideCVDFavoriteView,
} from "pages/home/CommonFunctions";

const BrandedCouponView = (props) => {
  const {
    selectedProduct,
    searchGaugeView,
    backToSearchGauge,
    selectedBrandedInfo,
    authData,
    selectedDosage,
    selectedQuantity,
    selectedForm,
    myCouponSelectedDosage,
    myCouponSelectedQuantity,
    myCouponSelectedForm,
    openSearchSettings,
    showGauge = false,
    fromPrescriptions = false,
    selectedPrescription = {},
    couponLowestPrice = {},
    brandDetailsNew,
    couponLowestPriceFromGauge,
    myCoupon,
    fromPOSViewCoupon = false,
    organizationInfo,
    selectedAlternateList,
  } = props;
  const selectedCouponItem =
    JSON.parse(localStorage.getItem("selectedCouponItem")) || {};
  const matches500MaxWidth = useMediaQuery("(max-width:600px)");
  const [showCouponDetailsView, setShowCouponDetailsView] = useState(false);
  const [selectedItem, setSelectedItem] = useState(
    fromPrescriptions
      ? selectedPrescription
      : myCoupon
      ? selectedCouponItem
      : {}
  );
   

  const checkVisibilty = () => {
    const result =
      hideCVDFavoriteView(authData) || handleDTCFavPharmacy(authData);
    return result;
  };

  const [hideFavoriteListView, setHideFavoriteListView] = useState(
    checkVisibilty()
  );
  const styles = {
    width: "90%",
    margin: "auto",
  };
  const favPharGroupId = localStorage.getItem("pharmacyGroupId");

  useEffect(() => {
    if (
      couponLowestPriceFromGauge &&
      Object.keys(couponLowestPriceFromGauge).length
    ) {
      setSelectedItem({
        ...couponLowestPriceFromGauge,
        triggerPharmacyNew:
          favPharGroupId && favPharGroupId !== "null" ? true : false,
      });
    }
  }, [couponLowestPriceFromGauge]);

  return (
    <>
      {searchGaugeView ? (
        <Card
          sx={{
            boxShadow: fromPOSViewCoupon ? "none" : undefined,
          }}
        >
          <MainTemplateHeader
            fromPOSViewCoupon={fromPOSViewCoupon}
            title={
              selectedBrandedInfo?.name ||
              selectedProduct?.productName ||
              selectedPrescription?.productName
            }
            backTitle={matches500MaxWidth ? false : true}
            noBack={true}
            showSearch={true}
            selectedDosage={
              fromPrescriptions ? brandDetailsNew?.strength : selectedDosage
            }
            selectedQuantity={
              fromPrescriptions
                ? brandDetailsNew?.quantity
                : selectedQuantity.quantity || ""
            }
            selectedForm={
              fromPrescriptions ? brandDetailsNew?.form : selectedForm
            }
            openSearchSettings={
              !fromPrescriptions &&
              openSearchSettings &&
              !selectedAlternateList?.productDetailId
                ? openSearchSettings
                : null
            }
            handleBackClick={() => {
              if (showCouponDetailsView && !hideFavoriteListView) {
                setHideFavoriteListView(checkVisibilty());
                setShowCouponDetailsView(false);
              } else {
                backToSearchGauge();
              }
            }}
          />

          <BrandedCouponDetails
            handleBackClick={backToSearchGauge}
            additionalStyles={styles}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            fromPrescriptions={fromPrescriptions}
            couponLowestPrice={couponLowestPrice}
          />
        </Card>
      ) : (
        <CouponDetailsTemplate minHeight="300shpx">
          <MainTemplateHeader
            title={selectedCouponItem.name}
            showSearch={true}
            backTitle={matches500MaxWidth ? false : true}
            selectedDosage={
              organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
              "y"
                ? myCouponSelectedDosage
                : undefined
            }
            selectedQuantity={
              organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
              "y"
                ? myCouponSelectedQuantity
                : undefined
            }
            selectedForm={
              organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
              "y"
                ? myCouponSelectedForm
                : undefined
            }
            openSearchSettings={
              !fromPrescriptions &&
              openSearchSettings &&
              !selectedAlternateList?.productDetailId
                ? openSearchSettings
                : null
            }
          />
          <BrandedCouponDetails
            selectedItem={selectedItem}
            additionalStyles={styles}
            showGauge={showGauge}
          />
        </CouponDetailsTemplate>
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    selectedProduct: state.home.selectedProduct,
    selectedBrandedInfo: state.globalStoreInfo.selectedBrandedInfo,
    organizationInfo: state.organizationInfo.data,
    authData: state.authentication.authData || {},
    selectedDosage: state.productDetails.selectedDosage,
    selectedForm: state.productDetails.selectedForm,
    selectedQuantity: state.productDetails.selectedQuantity,
    brandDetailsNew: state.brandDetailsNew.data || {},
    couponLowestPriceFromGauge: state.couponPrice.lowestPrice,
    selectedAlternateList: state.globalStoreInfo.selectedAlternateList,
  };
}

export default connect(mapStateToProps)(BrandedCouponView);
